import React from "react";
import {PaymentInfo} from "../../../model/PaymentInfo";
import {LoanData} from "../../../../loan-details/model/LoanData";
import {PaymentMethod} from "../../../model/PaymentMethod";
import {PrePaymentCreditCard} from "../credit-card/pre-payment-credit-card/PrePaymentCreditCard";
import {PrePaymentAch} from "../ach/pre-payment-ach/PrePaymentAch";
import {PrePaymentCreditCardWrapper} from "../wrapper/PrePaymentCreditCardWrapper";
import {FeeOptionKey} from "../../../../loan-details/component/FeeSelector";
import {PrePaymentAchWrapper} from "../wrapper/PrePaymentAchWrapper";


interface Props {
    info: PaymentInfo;
    loan: LoanData;
    disabled: boolean;
    selectedFees?: FeeOptionKey[];
}

export class PrePaymentMethodSwitch extends React.Component<Props> {

    private shouldShowFeeBreakdown = () => {
        return this.props.selectedFees && this.props.selectedFees.length > 0;
    };

    private getFeeDisplay = () => {
        if (this.props.selectedFees && this.props.selectedFees.length > 0) {
            let total = 0;
            if (this.props.selectedFees.includes("APPRAISAL")) {
                total += parseFloat(this.props.loan.appraisalFee.replace(/[$,]/g, ''));
            }
            if (this.props.selectedFees.includes("CREDIT_REPORT")) {
                total += parseFloat(this.props.loan.creditReportFee.replace(/[$,]/g, ''));
            }
            return total.toFixed(2);
        }

        if (this.shouldShowFeeBreakdownForNoSelection()) {
            const availableFee = this.getAvailableFeeForBreakdown();
            if (availableFee.length > 0) {
                return parseFloat(availableFee[0].amount.replace(/[$,]/g, '')).toFixed(2);
            }
        }

        return this.props.loan.appraisalFeeEnabled ? this.props.loan.appraisalFee : this.props.loan.creditReportFee;
    };

    private shouldShowFeeBreakdownForNoSelection = () => {
        const hasNoSelectedFees = !this.props.selectedFees || this.props.selectedFees.length === 0;
        return hasNoSelectedFees &&
               ((this.props.loan.appraisalFeeEnabled && !this.props.loan.creditFeeEnabled) ||
                (!this.props.loan.appraisalFeeEnabled && this.props.loan.creditFeeEnabled));
    };

    private getAvailableFeeForBreakdown = () => {
        if (this.props.loan.appraisalFeeEnabled && !this.props.loan.creditFeeEnabled) {
            return [{ key: "APPRAISAL" as FeeOptionKey, label: "Appraisal Fee", amount: this.props.loan.appraisalFee }];
        } else if (!this.props.loan.appraisalFeeEnabled && this.props.loan.creditFeeEnabled) {
            return [{ key: "CREDIT_REPORT" as FeeOptionKey, label: "Credit Report Fee", amount: this.props.loan.creditReportFee }];
        }
        return [];
    };

    render() {
        switch (this.props.info.method) {
            case PaymentMethod.CREDIT_CARD:
                return <PrePaymentCreditCardWrapper loan={this.props.loan}>
                    <PrePaymentCreditCard suggestedName={this.getSuggestedName()}
                                          fee={this.getFeeDisplay()}
                                          creditCardFee={this.props.loan.creditReportFee}
                                          paymentInfo={this.props.info}
                                          disabled={this.props.disabled}
                                          selectedFees={this.props.selectedFees}
                                          loan={this.props.loan}
                                          shouldShowBreakdownForNoSelection={this.shouldShowFeeBreakdownForNoSelection()}
                                          availableFeeForBreakdown={this.getAvailableFeeForBreakdown()}
                    />
                </PrePaymentCreditCardWrapper>
            case PaymentMethod.ACH:
                return <PrePaymentAchWrapper loan={this.props.loan}>
                    <PrePaymentAch paymentInfo={this.props.info}
                                   fee={this.props.loan.paymentAmount}
                                   disabled={this.props.disabled}
                    />
                </PrePaymentAchWrapper>
        }
    }

    private getSuggestedName = () => {
        let loanData = this.props.loan;
        return `${loanData.borrower.firstName} ${loanData.borrower.lastName}`;
    };

}
